import { createTheme } from "@mui/material/styles";
import { createTheme as createWeaveTheme } from "@weave-brand/core/theme";

import { weaveSelectLeakFix } from "@app/theme/overrides/fields.ts";
import { dhigLookOverrides } from "@app/theme/overrides/index.ts";
import { weaveSelectVariantFix } from "@app/theme/overrides/select.ts";
import { appPalette } from "@app/theme/palette.ts";
import { appSpacing } from "@app/theme/spacing.ts";
import { appTypography, fontFallbackOverrides } from "@app/theme/typography.ts";

/**
 * The one place that picks the Weave design system and colour mode. Switching
 * to the "brand" theme later is a change to `name` here (plus whatever visual
 * fixes that theme needs).
 */
export const WEAVE_THEME = { name: "legacy", mode: "light" } as const;

/**
 * App theme: Weave base, then the palette, spacing and typography built from
 * Weave tokens, then the override layer that keeps the look the app had under
 * Digital HIG.
 */
const weaveTheme = createWeaveTheme(WEAVE_THEME.name, {
  mode: WEAVE_THEME.mode,
});

const weaveWithFallbacks = createTheme(weaveTheme, {
  components: fontFallbackOverrides(weaveTheme.components),
});

export const appTheme = createTheme(
  weaveWithFallbacks,
  {
    components: {
      ...weaveSelectLeakFix(weaveWithFallbacks.components),
      ...weaveSelectVariantFix(weaveWithFallbacks.components),
    },
  },
  {
    palette: appPalette,
    spacing: appSpacing,
    typography: appTypography,
    components: dhigLookOverrides,
  }
);
